<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <div class="converter-select-container mb-3">
          <!-- <b-form-select v-model="selectedType" :options="convertTypes" class="mb-3 col-2">
          </b-form-select> -->
          <b-dropdown
            v-if="convertTypes.length > 0"
            id="ddown-header"
            :text="convertTypes.filter(t => t.value === selectedType)[0].text"
            class="convert-type-select">
            <b-dropdown-item-button
              v-for="(type, index) in convertTypes"
              :key="index"
              @click="selectedType = type.value">
              {{ type.text }}
            </b-dropdown-item-button>
          </b-dropdown>
          <p class="file-upload-title">{{ ls_Fileuploadlimtprompt }}</p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="document-control">
          <div class="custom-file-content">
            <div class="bg-upcloud"></div>
            <p class="virtual-placeholder">{{ ls_Uploadfile }}</p>
            <div class="bg-upformats"></div>
          </div>
          <b-form-file @change="uploadFiles()" ref="fileinput" v-model="files" :multiple="multiple" class="file-content"  :state="Boolean(files)" placeholder=""></b-form-file>
        </div>
        <div v-if="memoryFiles.length > 0" class="documents">
          <div v-for="item in memoryFiles" :key="item.id" class="document-item">
            <div class="document-name">
              <i
                v-if="item.fileName.substring(item.fileName.lastIndexOf('.')).includes('.doc')"
                class="fal fa-file-word word">
              </i>
              <i
                v-else-if="item.fileName.substring(item.fileName.lastIndexOf('.')).includes('.rtf')"
                class="fal fa-file-word word">
              </i>
              <i
                v-else-if="item.fileName.substring(item.fileName.lastIndexOf('.')).includes('.txt')"
                class="fal fa-file-alt txt">
              </i>
              <i
                v-else-if="item.fileName.substring(item.fileName.lastIndexOf('.')).includes('.pdf')"
                class="fal fa-file-pdf pdf">
              </i>
              <i
                v-else-if="item.fileName.substring(item.fileName.lastIndexOf('.')).includes('.xls')"
                class="fal fa-file-excel exel">
              </i>
              <i
                v-else-if="item.fileName.substring(item.fileName.lastIndexOf('.')).includes('.ppt')"
                class="fal fa-file-powerpoint ppt">
              </i>
              <i 
                v-else-if="item.fileName.substring(item.fileName.lastIndexOf('.')).includes('ml')"
                class="fal fa-file-code code">
              </i>
              <i v-else class="fal fa-file file"></i>
              {{ item.fileName.substring(0, item.fileName.lastIndexOf('.')) }}
            </div>
            <div class="document-upload-progress">
              <b-progress :class="[item.status === false ? 'info' : '']" :max="1" :animated="item.animated">
                <b-progress-bar :value="1">{{ item.errText }}</b-progress-bar>
              </b-progress>
            </div>
            <div class="document-info">
              <span class="extension-info">{{ item.fileName.substring(item.fileName.lastIndexOf('.')) }}</span>
              <b-link :href="item.downloadUrl" target="_blank" class="document-download" :title="item.downloadUrl">
                <i v-if="item.status === false" class="upload-err-icon fas fa-exclamation-circle"></i>
                <i v-else-if="item.status === true" class="fas fa-arrow-to-bottom"></i>
                <i v-else class="far fa-spinner loading"></i>
              </b-link>
              <span class="size-info">{{ item.fileSize }}</span>
            </div>
          </div>
        </div>
        <div v-if="hasItems" class="control-btns">
          <b-link v-if="hasConvertedItems"  @click.prevent="downloadFiles()" class="btn download-document">
            <span class="btn-name">
              {{ downloadAllBtn }}
            </span>
            <span class="btn-icon">
              <i class="far fa-arrow-down"></i>
            </span>
          </b-link>
          <b-link @click.prevent="clearFiles()" class="btn reset-btn">
            {{ resetBtn }}
          </b-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      selectedType: "",
      convertTypes: [],
      multiple: true,
      memoryFiles: [],
      files: [],
      downloadAllBtn: "Пакетті жүктеу",
      resetBtn: "Тазалау"
    };
  },
  computed: {
    host() {
      return this.$store.state.host;
    },
    hasItems() {
      return this.memoryFiles.length > 0;
    },

    hasConvertedItems() {
      return this.memoryFiles.some(item => item.status === true) ? true : false;
    },

    /**
     * These all for Language Pack
     */
    ls_Fileuploadlimtprompt() {
      return this.$store.state.languagePack.ls_Fileuploadlimtprompt;
    },
    ls_Uploadfile() {
      return this.$store.state.languagePack.ls_Uploadfile;
    },
    ls_FileConvertor() {
      return this.$store.state.languagePack.ls_FileConvertor;
    }
  },

  mounted() {
    this.getConvertTypes();
  },

  methods: {
    saveFileStatusToLocalStorage() {
      if (localStorage.getItem('filesInfo') !== null) {
        localStorage.removeItem('filesInfo');
      }

      if (this.memoryFiles.filter(f => f.status !== "static").length > 0) {
        localStorage.setItem('filesInfo', JSON.stringify(this.memoryFiles.filter(f => f.status === true)));
      }

      if (localStorage.getItem('fileConvertType') !== null) {
        localStorage.removeItem('fileConvertType');
      }
      
      localStorage.setItem('fileConvertType', this.selectedType);

      if (localStorage.getItem('fileLastConvertedTime') !== null) {
        localStorage.removeItem('fileLastConvertedTime');
      }

      localStorage.setItem('fileLastConvertedTime', Date.now())
    },
    removeFileStatusFromLocalStorage() {
      if (localStorage.getItem('filesInfo') !== null) {
        localStorage.removeItem('filesInfo');
      }

      if (localStorage.getItem('fileConvertType') !== null) {
        localStorage.removeItem('fileConvertType');
      }

      if (localStorage.getItem('fileLastConvertedTime') !== null) {
        localStorage.removeItem('fileLastConvertedTime');
      }
    },
    getFileStatusFromLocalStorage() {
      if (localStorage.getItem('filesInfo') !== null && localStorage.getItem('fileConvertType') !== null && localStorage.getItem('fileLastConvertedTime') !== null) {
        let lastSavedTime = Number(localStorage.getItem('fileLastConvertedTime'));
        if (Date.now() - lastSavedTime < 30 * 1000 * 1000) {
          return {
            selectedType: localStorage.getItem('fileConvertType'),
            filesInfo: JSON.parse(localStorage.getItem('filesInfo'))
          };
        }
      }

      localStorage.removeItem('fileConvertType');
      localStorage.removeItem('filesInfo');
      return null;
    },
    getConvertTypes() {
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getconverttypelist", fd)
        .then(result => {
          if (result.status === 200) {
            this.convertTypes = [];
            result.body.data.forEach(item =>
              this.convertTypes.push({
                value: item.convertKey,
                text: item.convertValue
              })
            );

            // let savedStatus = this.getFileStatusFromLocalStorage();

            // if (savedStatus !== null) {
            //   this.selectedType = savedStatus.selectedType;
            //   this.memoryFiles = savedStatus.filesInfo.filter(file => file.animated === false);
            // } else {
            //   this.selectedType = this.convertTypes[0].value;
            // }
            this.selectedType = this.convertTypes[0].value;
          } else {
            // console.log('Err');
          }
        });
    },

    uploadFiles() {
      this.removeFileStatusFromLocalStorage();
      setTimeout(() => {
        this.memoryFiles
          .filter(item => item.status === "static")
          .forEach(item => {
            item.animated = true;

            var formData = new FormData();
            formData.append("language", this.$route.params.ln);
            formData.append("convertType", this.selectedType);
            formData.append("dFile", item.file);

            this.$http
              .post(
                this.host + "/api/convert/documentcontent",
                formData,
                { timeout: 600000 }
              )
              .then(
                response => {
                  item.animated = false;
                  if (response.status === 200) {
                    if (JSON.parse(response.bodyText).status === "success") {
                      this.memoryFiles.find(
                        f => f.id === item.id
                      ).status = true;
                      this.memoryFiles.find(f => f.id === item.id).downloadUrl =
                        "" +
                        JSON.parse(response.bodyText).data;
                      this.saveFileStatusToLocalStorage();
                    } else {
                      this.memoryFiles.find(
                        f => f.id === item.id
                      ).status = false;
                      this.memoryFiles.find(
                        f => f.id === item.id
                      ).errText = JSON.parse(response.bodyText).message;
                    }
                  } else {
                    this.memoryFiles.find(f => f.id === item.id).status = false;
                    this.memoryFiles.find(f => f.id === item.id).errText =
                      "Time out!";
                  }
                },
                response => {
                  item.animated = false;
                  this.memoryFiles.find(f => f.id === item.id).status = false;
                  this.memoryFiles.find(f => f.id === item.id).errText =
                    "Time out!";
                }
              );
          });
      }, 100);
    },

    downloadFiles() {
      var concatedLinks = this.host + "/api/convert/downloadzip?";

      this.memoryFiles
        .filter(item => item.status === true)
        .forEach(
          item =>
            (concatedLinks +=
              "&fileNameList=" +
              item.downloadUrl.substring(
                item.downloadUrl.lastIndexOf("/uploads/")
              ))
        );

      window.location.href = concatedLinks;
    },

    clearFiles() {
      this.memoryFiles = [];
      this.$refs.fileinput.reset();
      this.removeFileStatusFromLocalStorage();
    }
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getConvertTypes();
      }
    },

    files() {
      let f = this.files.slice(0, 5);
      f.forEach(file =>
        this.memoryFiles.unshift({
          id: this.memoryFiles.length,
          file: file,
          fileName: file.name,
          fileSize: Number.parseFloat(file.size / 1024).toFixed(2) > 1024 ? Number.parseFloat(file.size / (1024 * 1024)).toFixed(2) + 'MB' : Number.parseFloat(file.size / 1024).toFixed(2) + 'kb',
          status: "static",
          downloadUrl: "javascript:void(0);",
          errText: "",
          animated: false
        })
      );
    }
  },

  metaInfo() {
    return {
      title: this.ls_FileConvertor
    };
  }
};
</script>

<style lang="scss">
$uploaderContentHeight: 15rem;

.document-control {
  height: $uploaderContentHeight + 4.125rem;
  margin-bottom: 1rem;
  position: relative;

  &:hover {
    .custom-file-content {
      border-color: #444444;
    }
  }

  .custom-file-content {
    position: absolute;
  }
}

.converter-select-container {
  .custom-select {
    background: #fff
      url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 129 129'%3E%3Cpath fill='%23343a40' d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z'/%3E%3C/svg%3E")
      no-repeat right 0.75rem center;
    background-size: 1.125rem 1.125rem;

    &:focus {
      box-shadow: none;
    }
  }
}

.file-upload-title {
  color: #706f70;
  font-size: 0.875rem;
  text-align: center !important;
  margin-top: -20px;
  padding-left: 220px;
}

.file-content {
  height: $uploaderContentHeight + 2.375rem !important;
  border-radius: 0.25rem;

  .custom-file-input {
    cursor: pointer;
    height: $uploaderContentHeight + 2.375rem !important;
  }

  .custom-file-input:lang(en) ~ .custom-file-label {
    display: none !important;
    border-radius: 0.25rem;
    border: 0;
    height: $uploaderContentHeight + 2.375rem !important;
    background-color: transparent;
    padding-top: 2.375rem;
    padding-bottom: 2.375rem;
  }
  .custom-file-label,
  .custom-file-label::after {
    display: none !important;
  }

  .custom-file-input:lang(en) ~ .custom-file-label::after {
    display: none !important;
  }
  .was-validated .custom-file-input:valid:focus ~ .custom-file-label,
  .custom-file-input.is-valid:focus ~ .custom-file-label {
    box-shadow: 0 0 0 0.2rem rgba(59, 204, 240, 0.25);
  }
}

.custom-file-content {
  height: $uploaderContentHeight + 2.375rem;
  width: 100%;
  border-radius: 0.25rem;
  border: 2px dashed #b0b2b4;
  padding-bottom: 2.375rem;
  transition: all 0.2s ease-in-out;

  .bg-upcloud {
    height: 6.25rem;
    margin-top: 2.5rem;
    background: url("~/images/file_click.png") no-repeat center;
    background-size: 7.125rem;
  }
  .bg-upformats {
    height: 3.125rem;
    background-image: url("~/images/icons.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 3.125rem;
    margin-top: 1.5rem;
  }
  .virtual-placeholder {
    text-align: center;
    color: #848484;
  }
}

.convert-type-select {
  width: 200px;
  margin: 0 0 0 -1px !important;

  .dropdown-menu {
    width: 100%;
    border-radius: 3px;

    .dropdown-item {
      padding: 4px 12px;

      &:focus {
        outline: none;
      }

      &:hover {
        background-color: #00849022;
      }
    }
  }

  .dropdown-toggle {
    border-color: #ced4da !important;
    color: #706f70 !important;
    width: 100%;
    text-align: left;
    border-radius: 3px;
    background: #f6f6f6
      url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 129 129'%3E%3Cpath fill='%23343a40' d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z'/%3E%3C/svg%3E")
      no-repeat right 0.75rem center !important;
    background-size: 14px 14px !important;

    &:focus, &:hover, &:focus:hover {
      outline: none !important;
      box-shadow: none !important;
      border-color: #ced4da;
      background-color: #f0f0f0 !important;
    }

    &::after {
      border: none !important;
    }
  }
}

.documents {
  margin-bottom: 3rem;
  box-shadow: 0 0 35px 10px #11111110;

  .document-item {
    background: #ffffff;
    font-size: 0.75rem;
    height: 40px;
    line-height: 1;
    padding: 1rem;
    margin-bottom: 0.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e5e6e7;

    .document-name {
      font-size: 14px;
      color: #3b5356;
      font-family: Robobto, Arial, Helvetica, sans-serif;
      width: 550px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      i {
        margin-right: 10px;
      }

      .word {
        color: #9ba6ca;
      }
      .txt {
        color: #929497;
      }
      .pdf {
        color: #f8a98f;
      }
      .exel {
        color: #9daf97;
      }
      .ppt {
        color: #e2ad90;
      }
      .code {
        color: #f3b192;
      }
      .file {
        color: #706f70;
      }
    }

    .document-upload-progress {
      width: 100%;

      .progress {
        height: 12px;
        background-color: #ffffff;

        .progress-bar {
          background-color: #a0cc39;
          font-size: 10px !important;
        }
      }

      .info {
        .progress-bar {
          background-color: #dc3545;
        }
      }
    }

    .upload-err-icon {
      color: #dc3545;
    }

    .document-info {
      width: 400px;

      .extension-info {
        font-family: Roboto, Arial, Helvetica, sans-serif;
        font-size: 14px;
        margin-right: 0.375rem;
      }

      .size-info {
        float: right;
        font-family: Roboto, Arial, Helvetica, sans-serif;
        font-size: 13px;
        color: #a5ce3e;
        line-height: 0.875rem;
      }

      .document-download {
        float: right;
        color: #706f70;
        font-size: 0.875rem;
        margin-left: 0.875rem;

        &:hover {
          color: rgb(89, 142, 240);
        }
      }
    }
  }
}

.control-btns {
  text-align: center;
  padding-top: 8px;
}

.download-document {
  position: relative;
  border: 1px solid #00667133 !important;
  border-radius: 0.25rem;
  padding: 0 !important;
  overflow: hidden;

  .btn-name {
    display: inline-block;
    padding: 0.5rem 0.25rem 0.5rem 0.75rem;
    color: #ffffff;
    font-size: 0.875rem;
    font-weight: 600;
    background-color: #038395;
    transition: all 0.7s;
  }

  .btn-icon {
    display: inline-block;
    padding: 0.5rem 0.75rem 0.5rem 1rem;
    color: #ffffff;
    font-size: 0.875rem;
    margin-left: 0;
    background-color: #038395;
    transition: all 0.7s;
  }

  &:hover {
    .btn-name {
      background-color: #006571;
      color: #ededed;
    }

    .download-devider {
      color: #038395;
    }

    .btn-icon {
      color: #ededed;
      background-color: #006571;
    }
  }
}

.control-btns {

  .reset-btn {
    background: #ff1744;
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    font-size: 0.875rem !important;
    padding: 0.45rem 0.875rem !important;
    border: 0;
    margin-left: 1rem;
    color: #ffffff;
    transition: all 0.7s;

    &:hover {
      color: #f0f0f0;
      background-color: #b2102f;
    }
  }
}

.loading {
  -webkit-animation: rotation 1.5s infinite linear;
  animation: rotation 1.5s infinite linear;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
@keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}

/*
  RTL
*/

.rtl-layout {
  .file-upload-title {
    padding-left: 0;
    padding-right: 220px;
  }
}
</style>
